import { brandListsPage } from '../configs/tools/shared-library/brand-lists';

export const brandLists = {
  ...brandListsPage,
  name: _TL_('Brand lists'),
  description: _TL_('Manage your brand lists for brand protection and brand exclusion.'),
};
